module.exports = __webpack_public_path__ + "static/media/flatbed-active.6e50c8d8.svg";